import Admin from "./Admin";
import Author from "./Author";

export default {
  Admin,
  Author
};
